var _a;
import * as React from 'react';
import { watch } from '../builds/watch';
// SSR guard (mirrors useAuth): no hooks/subscriptions during Node server render.
// React Native has no `window` but DOES support hooks, so detect Node SSR
// specifically via process.versions.node.
const isSSR = typeof window === 'undefined'
    && typeof process !== 'undefined'
    && !!((_a = process.versions) === null || _a === void 0 ? void 0 : _a.node);
export function useBuildRun(appId, runId, options) {
    if (isSSR) {
        return { run: null, events: [], loading: true, error: null };
    }
    const [run, setRun] = React.useState(null);
    const [events, setEvents] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [error, setError] = React.useState(null);
    const optionsKey = options ? JSON.stringify(options) : '';
    React.useEffect(() => {
        setRun(null);
        setEvents([]);
        setError(null);
        if (!appId || !runId) {
            setLoading(false);
            return;
        }
        let active = true;
        setLoading(true);
        const handle = watch(appId, runId, ({ run: nextRun, events: nextEvents }) => {
            if (!active)
                return;
            setRun(nextRun);
            if (nextEvents.length > 0) {
                setEvents((current) => {
                    const seen = new Set(current.map((event) => event.seq));
                    return [...current, ...nextEvents.filter((event) => !seen.has(event.seq))];
                });
            }
            setError(null);
            setLoading(false);
        }, Object.assign(Object.assign({}, options), { onError: (value) => {
                if (!active)
                    return;
                setError(value instanceof Error ? value : new Error(String(value)));
                setLoading(false);
            } }));
        return () => {
            active = false;
            handle.stop();
        };
        // optionsKey captures the option object's contents; ids are the other inputs.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appId, runId, optionsKey]);
    return { run, events, loading, error };
}
